<template>
	<div class="collect-app">
		<div class="collect">
			<div class="user-title">
				<span>我的收藏</span>
			</div>
			<div class="collect-list" v-if="collectList && collectList !== ''">
				<div class="list-box" v-for="(item,index) in collectList" :key="index">
					<!-- :class="{'list-box-active' : listBoxActive == index}" -->
					<div class="list-tab-a-box">
						<div class="list-tab-a" @click="slideOpen(index,item.count)">
							<i></i>
							<p>{{item.name}}</p>
							<div style="margin-left: 20px;font-size: 12px;">题数：<span
									style="font-weight: bold;color: #e60012">{{item.count &&  item.count>0  ? item.count : 0 }}</span></div>
						</div>
					</div>
					<el-collapse-transition>
						<div class="contant" v-if="listBoxActive == index">
							<!-- <div v-for="(item2,index2) in item.data ">{{item2.sub_text}}</div> -->
							<div class="list-tab-b-box" v-for="(v,index2) in item.data" :key="index2"
								@click="openWrongAnswer(v.sub_id,v.type||2,item.count)">
								<div class="list-tab-b">
									<p>{{v.sub_text}}</p>
									<div style="margin-left: 20px;font-size: 12px;">题数：<span
											style="font-weight: bold;color: #e60012">{{v.count}}</span></div>
								</div>
							</div>
						</div>
					</el-collapse-transition>
				</div>
			</div>
			<div v-else style="padding:20px 0; text-align:center">暂无数据</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "",
		data() {
			return {
				listBoxActive: "-1",
				collectList: [

				],
				limit: '10',
				page: '10'


			};

		},
		methods: {
			slideOpen(index,count) {
				if(count === undefined || count == 0){
						return
				}	
				if (this.listBoxActive == index) {
					this.listBoxActive = "-1";
				} else {
					this.listBoxActive = index;
				}
			},
			async getCollectData() {
				//console.log("1111111111")
				let userinfo = JSON.parse(localStorage.getItem('userInfo'))
				const {
					data: res
				} = await this.$api.getUserCollect({
					user_id: userinfo.id
				})
				//console.log(res)
				this.collectList = res
				for (let i of this.collectList) {
					let n = 0
					//console.log(i)
					for (let s of i.data) {
						n += s.count
						i.count = n
					}


				}
				//console.log(this.collectList)
				//console.log("this.collectList.name")
				//console.log(this.collectList)



				// this.$loading();
				// var param = {
				// 	uid: uid,
				// };
				// this.$post("userfavorite", param).then((res) => {
				// 	this.collectList = res.data;
				// });
				// setTimeout(() => {
				// 	this.$loading().close();
				// }, 500);
			},
			openCircleAnswer(index) {
				var list = this.collectList[index];
				for (let i = 0; i < Object.keys(list).length - 2; i++) {
					if (list[i].scnum > 0) {
						var id = list[i].answer_id;
					}
					break;
				}
				this.$router.push({
					path: "/answer",
					query: {
						qid: id,
					},
				});
			},
			openWrongAnswer(id,type,number) {
				this.$router.push({
					path: "/answerFavorite",
					query: {
						result_id: id,
						type:type,
						answer_number:number
					},
				});
			},
		},
		created() {
			this.getCollectData();
		},
	};
</script>

<style>
	.list-tab-b-box{
		padding-left: 20px;
	}
	.collect {
		padding: 0 40px 30px 40px;
	}

	.collect-list {
		border: 1px solid #ebebeb;
		margin-top: 30px;
		padding: 0 15px;
		padding-bottom: 15px;
		border-radius: 10px;
	}

	.collect-list .list-box:last-child {
		border-bottom: none;
	}

	.list-tab-a,
	.list-tab-b {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		height: 50px;
		border-bottom: 1px solid #ebebeb
	}

	.list-box-active .contant {
		display: block;
		padding-left: 15px;
	}

	.list-tab-sj i {
		background: none;
		border: 1px solid #ccc;
		border-radius: 100%;
	}
</style>
